/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionSafe
 */
export interface SubscriptionSafe {
    /**
     * The Stripe subscription ID
     * @type {string}
     * @memberof SubscriptionSafe
     */
    id: string;
    /**
     * The plan nickname for this subscription
     * @type {string}
     * @memberof SubscriptionSafe
     */
    name: string;
}

/**
 * Check if a given object implements the SubscriptionSafe interface.
 */
export function instanceOfSubscriptionSafe(value: object): value is SubscriptionSafe {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SubscriptionSafeFromJSON(json: any): SubscriptionSafe {
    return SubscriptionSafeFromJSONTyped(json, false);
}

export function SubscriptionSafeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionSafe {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function SubscriptionSafeToJSON(json: any): SubscriptionSafe {
    return SubscriptionSafeToJSONTyped(json, false);
}

export function SubscriptionSafeToJSONTyped(value?: SubscriptionSafe | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

